import React, { useState } from 'react'

import {
    Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, useMediaQuery,
    FormControl, Select, MenuItem, Button
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

const AcceptDialog = ({ isOpen, onClose, onConfirm }) => {

    const [loaLevel, setLoaLevel] = useState(2);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleLoaChange = (event) => {
        console.log("LOA: ", event.target.value)
        setLoaLevel(event.target.value)
    }

    return (

        <Dialog
            fullScreen={fullScreen}
            open={isOpen}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
            sx={{
                "& .MuiPaper-root": {
                    border: '2px solid #264E5A',
                    borderRadius: '8px',
                    padding: '1rem',
                }
            }}>

            <DialogTitle id="responsive-dialog-title">Confirm your approve decision</DialogTitle>

            <DialogContent>
                <DialogContentText>
                    Are you sure you want to approve this application? Once approved,
                    the application status will be updated, and this action cannot be undone.
                </DialogContentText>

                <FormControl size="small" sx={{
                    minWidth: 120, height: '40px', marginTop: '1rem'
                }}>
                    <Select
                        value={loaLevel}
                        onChange={handleLoaChange}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                        sx={{
                            color: '#264E5A', fontWeight: '500', fontSize: '14px',
                            borderRadius: '8px', height: '100%', outline: 'none',
                            border: '1px solid #264E5A', backgroundColor: '#D4ECEF'
                        }}>
                        <MenuItem value={2} selected>LOA 2</MenuItem>
                        <MenuItem value={3}>LOA 3</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>

            <DialogActions sx={{ padding: '1rem 1.5rem' }}>
                <Button
                    variant='outlined'
                    autoFocus
                    onClick={onClose}
                    sx={{
                        borderColor: "#00707E",
                        color: '#00707E',
                        padding: '1rem 3rem',
                        textTransform: 'none'
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    onClick={() => onConfirm(loaLevel)}
                    autoFocus
                    sx={{
                        backgroundColor: "#00707E",
                        padding: '1rem 3rem',
                        textTransform: 'none'
                    }}
                >
                    Confirm approve
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AcceptDialog